import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { OnChange } from 'react-final-form-listeners'
import { Select } from 'antd';
// Local deps
import './RFFSelectCountry.scss';
// import RFFRadio from './index';
import Countries from '../../../config/countries.json';

const Option = Select.Option;

function RFFSelectCountryField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  changeSelectValue,
  mode,
  // country,
  onCountryChange,
  defaultValue,
  ...otherProps,
}) {
  const _OnChange = value => {
    if (changeSelectValue) {
      changeSelectValue(input, value);
    } else {
      input.onChange(value);

    }
  };

  const countries = Object.keys(Countries).map(country => (
    <Option value={country} label={country}>{Countries[country]}</Option>
  ));


  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <Select
            className="nf-rff-input-field__input"
            optionLabelProp="label"
            {...input}
            {...otherProps}
            onChange={_OnChange}
          >
            {countries}
          </Select>
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
      {onCountryChange && <OnChange name={input.name}>
        {(value) => {
          onCountryChange(value)
        }}
      </OnChange>}



    </div>
  );
}

RFFSelectCountryField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
};

RFFSelectCountryField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  // options: PropTypes.array.isRequired,
  // country: PropTypes.string.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
  changeSelectValue: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
};

export default RFFSelectCountryField;



// WEBPACK FOOTER //
// ./src/components/form/RFFSelectCountry/RFFSelectCountry.jsx